"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordDocsService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordDocsService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordDocsService.instance) {
      return CordDocsService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordDocsService.instance = this;
  }
  uploadDocument(data) {
    return this.post('document', data);
  }
  uploadDocumentVersion(data) {
    return this.post('document/version', data);
  }
  updateDocumentStatus(data) {
    return this.post('document/status', data);
  }
  searchDocument(data) {
    return this.post('document/search', data);
  }
  getDocumentById(documentId) {
    return this.get(`document/${documentId}`);
  }
  getDocumentVersionBase64(versionId) {
    return this.get(`document/version/${versionId}`);
  }
  deleteDocument(documentId) {
    return this.delete(`document/${documentId}`);
  }
  deleteDocumentVersion(versionId) {
    return this.delete(`document/version/${versionId}`);
  }
  updateDocumentArchiveStatus(data) {
    return this.patch('document/archive', data);
  }
  mergeDocuments(data) {
    return this.post('document/mergeDocuments', data);
  }
}
exports.CordDocsService = CordDocsService;
CordDocsService.instance = null;
